import JosephWaters from '@listening/assets/astro/images/Frame-1362789785-2_1.png';
import JudyAdams from '@listening/assets/astro/images/Frame-1362789785-5.png';
import SamanthaLumby from '@listening/assets/astro/images/new-design-25/ui/avatar-testimonial-9.png';
import { Quote } from 'iconoir-react';
import { cn } from '@listening/utils/react-helpers';
import * as m from '@/paraglide/messages';
import { SectionHeading } from './section-heading';

function Author({
  name,
  avatar,
  size,
}: {
  name: string;
  avatar: string;
  size: 'lg' | 'sm';
}) {
  return (
    <figcaption className='flex items-center gap-3'>
      <img
        alt=''
        className={
          size === 'lg'
            ? 'size-12 rounded-full object-cover'
            : 'size-9 rounded-full object-cover'
        }
        height={size === 'lg' ? 48 : 36}
        src={avatar}
        width={size === 'lg' ? 48 : 36}
      />
      <span className='text-sm font-semibold text-(--v2-text-primary)'>
        {name}
      </span>
    </figcaption>
  );
}

function SmallQuote({
  quote,
  name,
  avatar,
  className,
}: {
  quote: string;
  name: string;
  avatar: string;
  className?: string;
}) {
  return (
    <figure
      className={cn(
        'flex flex-col justify-between gap-4 rounded-3xl bg-(--v2-app-bg) p-5 ring-1 ring-black/[0.05] sm:gap-6 sm:p-6',
        className,
      )}
    >
      <blockquote className='text-sm leading-relaxed text-(--v2-text-primary) sm:text-[15px]'>
        {quote}
      </blockquote>
      <Author avatar={avatar} name={name} size='sm' />
    </figure>
  );
}

export function TestimonialsSection() {
  return (
    <section
      aria-labelledby='why-testimonials-heading'
      className='px-5 py-14 sm:px-6 sm:py-20 lg:py-24'
    >
      <SectionHeading
        description={m.why_listening_testimonials_description()}
        eyebrow={m.why_listening_testimonials_eyebrow()}
        id='why-testimonials-heading'
        title={m.why_listening_testimonials_title()}
      />
      <div className='mx-auto mt-10 grid max-w-5xl gap-2.5 sm:mt-14 lg:grid-cols-[minmax(0,1.5fr)_minmax(0,1fr)]'>
        <figure className='relative flex flex-col justify-between gap-4 overflow-hidden rounded-3xl bg-(--v2-app-bg) p-5 ring-1 ring-black/[0.05] sm:gap-6 sm:p-9'>
          <Quote aria-hidden='true' className='size-5 text-azure-595' />
          <blockquote className='text-lg leading-snug font-medium tracking-[-0.025em] text-balance text-(--v2-text-primary) sm:text-2xl'>
            {m.testimonial_joseph_waters()}
          </blockquote>
          <Author avatar={JosephWaters} name='Joseph Waters' size='lg' />
        </figure>
        <div className='grid gap-3'>
          <SmallQuote
            avatar={SamanthaLumby}
            name='Samantha Lumby'
            quote={m.testimonial_samantha_lumby()}
          />
          <SmallQuote
            avatar={JudyAdams}
            className='hidden sm:flex'
            name='Judy Adams'
            quote={m.testimonial_judy_adams()}
          />
        </div>
      </div>
    </section>
  );
}
